export class AdvisorUserModel implements IAdvisorUserModel {
  dateCreated?: Date | undefined;
  isPrimary?: boolean | undefined;
  advisorPersonId?: string | undefined;

  constructor(data?: IAdvisorUserModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.isPrimary = Data["isPrimary"];
      this.advisorPersonId = Data["advisorPersonId"];
    }
  }

  static fromJS(data: any): AdvisorUserModel {
    data = typeof data === 'object' ? data : {};
    let result = new AdvisorUserModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["isPrimary"] = this.isPrimary;
    data["advisorPersonId"] = this.advisorPersonId;
    return data;
  }
}

export interface IAdvisorUserModel {
  dateCreated?: Date | undefined;
  isPrimary?: boolean | undefined;
  advisorPersonId?: string | undefined;
}
